<template>
  <section class="moderator-marketing-mailings-history">
    <div class="moderator-marketing-mailings-history__header">
      <h1 class="moderator-marketing-mailings-history__title">
        {{ $tModeratorMarketing('History') }}
      </h1>
      <button @click.prevent="onToggleContent"
              :class="{_open: isOpen}"
              class="moderator-marketing-mailings-history__toggle-list  inline-link  _dotted">
        <span v-if="isOpen">{{ $tModeratorMarketing('Hide history') }}</span>
        <span v-else>{{ $tModeratorMarketing('Show history') }}</span>

        <BaseSvg name="ico-arrow-light"></BaseSvg>
      </button>
    </div>

    <div v-if="pending">
      <BasePreloader/>
    </div>
    <ErrorView v-else-if="error"
               :code="error.code"
               :title="error.message"
               class="container-inner"/>

    <CollapseTransition v-if="receivedData">
      <div v-if="isOpen"
           class="moderator-marketing-mailings-history__content">
        <div class="moderator-marketing-mailings-history__table">
          <div class="moderator-marketing-mailings-history__table-row  _head  d-md-none">
            <div class="moderator-marketing-mailings-history__table-cell  _head  _target">
              <div style="margin-bottom: 1.4rem">
                {{ $tModeratorMarketing('Sent date') }}
              </div>
              <div>
                {{ $tModeratorMarketing('Mailing purpose') }}
              </div>
            </div>
            <div class="moderator-marketing-mailings-history__table-cell  _head  _role">
              {{ $tModeratorMarketing('option_role') }}
            </div>
            <div class="moderator-marketing-mailings-history__table-cell  _head">
              {{ $tModeratorMarketing('option_have_sent') }}
            </div>
            <div class="moderator-marketing-mailings-history__table-cell  _head">
              {{ $tModeratorMarketing('option_bot_subscribe') }}
            </div>
            <div class="moderator-marketing-mailings-history__table-cell  _head">
              {{ $tModeratorMarketing('option_have_favorites') }}
            </div>
            <div class="moderator-marketing-mailings-history__table-cell  _head">
              {{ $tModeratorMarketing('option_have_primary') }}
            </div>
            <div class="moderator-marketing-mailings-history__table-cell  _head">
              {{ $tModeratorMarketing('option_age') }}
            </div>
            <div class="moderator-marketing-mailings-history__table-cell  _head">
              {{ $tModeratorMarketing('option_gender') }}
            </div>
            <div class="moderator-marketing-mailings-history__table-cell  _head">
              {{ $tModeratorMarketing('option_place') }}
            </div>
            <div class="moderator-marketing-mailings-history__table-cell  _head  _channels">
              {{ $tModeratorMarketing('option_channels') }}
            </div>
            <div class="moderator-marketing-mailings-history__table-cell  _head  _toggle">
            </div>
          </div>
          <template v-for="item in receivedData">
            <AMMarketingMailingsHistoryRow :key="item.id"
                                           :item="item"
                                           :isOpen="openRowId === item.id"
                                           @toggle="onToggleRow(item.id)"/>

            <AMMarketingMailingsHistoryMessages :key="item.id + 'messages'"
                                                :item="item"
                                                :isOpen="openRowId === item.id"
                                                :getChangeLabel="getChangeLabel"/>
          </template>
        </div>
        <div class="moderator-marketing-mailings-history__footer">
          <Pagination :quantity="pagination.last_page"
                      :withGoTo="false"/>
        </div>
      </div>
    </CollapseTransition>

  </section>
</template>

<script>
  import {http} from '@/axios'
  import handleError from '@/helpers/handleError'
  import ErrorView from '@/components/ErrorView'
  import AMMarketingMailingsHistoryRow from '@/components/moderatorMarketingMailings/AMMarketingMailingsHistoryRow'
  import AMMarketingMailingsHistoryMessages
    from '@/components/moderatorMarketingMailings/AMMarketingMailingsHistoryMessages'
  import Pagination from '@/components/Pagination'
  import {CollapseTransition} from 'vue2-transitions'

  export default {
    name: 'AMMarketingMailingsHistory',
    components: {
      Pagination,
      ErrorView,
      AMMarketingMailingsHistoryRow,
      AMMarketingMailingsHistoryMessages,
      CollapseTransition,
    },
    props: {
      getChangeLabel: Function
    },
    data() {
      return {
        loaded: false,
        error: null,
        pending: false,
        receivedData: null,
        openRowId: null,
        isOpen: false,

        pagination: {
          total: 0,
          last_page: 0
        }
      }
    },
    methods: {
      load() {
        if (!this.isOpen) return
        if (this.loaded || this.pending) return

        this.pending = true

        return http.get('/api/backoffice/mailing/list', {
          params: {
            page: this.$route.query.page
          }
        })
            .then(({data}) => {
              this.receivedData = data.data.data
              this.pagination.total = data.data.total
              this.pagination.last_page = data.data.last_page

              this.loaded = true
            })
            .catch(e => {
              this.error = {
                code: e.response && e.response.status,
                message: handleError(e)
              }
            })
            .finally(() => {
              this.pending = false
            })
      },

      onToggleRow(id) {
        this.openRowId = this.openRowId === id ? null : id
      },

      onToggleContent() {
        this.isOpen = !this.isOpen

        if (this.isOpen) {
          this.load()
        }
      }
    },
    created() {
      this.load()
    },
    watch: {
      '$route.query.page'() {
        this.loaded = false
        this.load()
      }
    }
  }
</script>

<style lang="less">

</style>
